module.exports = {
  login:'Anmelden',
  taption: 'Taption',
  ways_to_use_taption:'Verwendungszwecke von Taption',
  faq:'FAQ',
  pricing:'Preise',
  language:'Sprache',
  product:'Produkte'
}
